import { memo, ReactElement, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { isMobile } from 'utils/is-mobile';
import { QuickBetComponent } from 'newelements/_Betslip/components/shared/Features/QuickBet/QuickBet';
import { toggleBetslip } from 'newelements/_Betslip/managers/ToggleManager/toggle-betslip-options';
import { LoadingInProcess } from 'newelements/_Betslip/views/LoadingInProcess';
import { QuickbetToggle } from 'components/QuickbetToggle';
import {
  getQuickBetEnabled,
  getQuickBetInProcessCount
} from 'store/selectors/betslip';
import { getIsLoggedIn } from 'store/selectors/user-data';

export const QuickBet = memo((): ReactElement | null => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const isQuickBetEnabled = useSelector(getQuickBetEnabled);
  const quickBetInProcessCount = useSelector(getQuickBetInProcessCount);

  const isQuickBetVisible = isQuickBetEnabled && isMobile() && isLoggedIn;

  return (
    <>
      {isQuickBetVisible ? (
        <Suspense>
          <QuickBetComponent />
        </Suspense>
      ) : null}

      {isMobile() && isLoggedIn && (
        <Suspense>
          <QuickbetToggle
            quickBet={isQuickBetEnabled}
            onClick={() => toggleBetslip()}
          />
        </Suspense>
      )}
      {/* @Todo lazy import */}
      {isQuickBetEnabled && quickBetInProcessCount > 0 ? (
        <LoadingInProcess count={quickBetInProcessCount} />
      ) : null}
    </>
  );
});
